/**
 * Theatre House — custom.js
 */

(function () {
  'use strict';

  function moveTHQuoteCTA() {
    var quoteWrapper = document.querySelector('.th-quote-wrapper');
    if (!quoteWrapper) return false;
    var quoteItem = quoteWrapper.closest('.product-info__block-item');
    var buyItem   = document.querySelector('.product-info__block-item--buy-buttons');
    if (!quoteItem || !buyItem) return false;
    if (buyItem.nextElementSibling === quoteItem) return true;
    buyItem.after(quoteItem);
    return true;
  }

  function initQuoteCTA() {
    if (!moveTHQuoteCTA()) {
      var observer = new MutationObserver(function () {
        if (moveTHQuoteCTA()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { observer.disconnect(); }, 6000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuoteCTA);
  } else {
    initQuoteCTA();
  }

  document.addEventListener('variant:changed', moveTHQuoteCTA);
}());
